import { useCallback, useMemo } from "react";
import C360ReactTracker from "@bookingcom/c360-tracker-react";

import useUserAgent from "./useUserAgent";
import useGlobalContext from "./useGlobalContext";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import useEvents from "./useEvents";
import { UIXc360Data } from "../cross-sell/types";
import { BOOKING_DEFAULT_AFFILIATE_ID, BOOKING_DEFAULT_LABEL } from "@flights/constants";

const useC360Tracker = () => {
  const { isMobile } = useUserAgent();
  const { currencyCode, env, locale = "en-gb", sessionId } = useGlobalContext();
  const { jsError, grumble } = useEvents();

  const initC360 = useCallback(() => {
    C360ReactTracker.init({
      aid: flightsSessionStore.get("aid") || BOOKING_DEFAULT_AFFILIATE_ID,
      currency: currencyCode,
      isDev: env !== "prod",
      label: flightsSessionStore.get("label") || BOOKING_DEFAULT_LABEL,
      lang: locale,
      onErrorCallback: (error) => jsError(error),
      platform: isMobile ? "mdot" : "ddot",
      sessionId
    });
  }, [currencyCode, env, isMobile, jsError, locale, sessionId]);

  const c360SendEvent = useCallback(
    async (data: UIXc360Data) => {
      if (!C360ReactTracker.c360Config) {
        grumble("c360SendEvent: C360 ReactTracker is not initialised. Event was not send.", { ...data });
        return;
      }

      await C360ReactTracker.sendEvent(data);
    },
    [grumble]
  );

  return useMemo(() => ({ initC360, c360SendEvent }), [initC360, c360SendEvent]);
};

export default useC360Tracker;
